module.exports = __webpack_public_path__ + "static/Cybersecurity_1020virtual-a074f57d786338dec8ccd15a0339835d.png";